import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { SkeletonCard } from "../../Loader/Loader.jsx";
import { useCommon } from "../../../Hooks/Common/useCommon.js";
import nodata from '../../../assets/nodata.jpg';
import { useGateKeeper } from "../../../Hooks/Features/Gatepass/useGateKeeper.js";
import DatePicker from 'react-multi-date-picker';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CommanDialog from "../../CommonCompo/CommanDialog/CommanDialog.js";
import { convertTo12HourFormat, dateConvert } from "../../../utils/Helper.js";


export const GateKeeper = () => {
  const { checkPermission } = useCommon();
  const { tagRef, loader, tabsList, hoveredRange, setHoveredRange, getGatepassRequestStatusInfo, isFilterApplied, setIsFilterApplied, handleActions, showPopup, setShowPopup } = useGateKeeper();

  return (
    <div ref={() => checkPermission(("Gatekeeper", tagRef))}>
      <div ref={tagRef} id='{"tabname": "gate_pass", "data": "gatepass_gatekeeper_tab"}' >
        <div>
          <DatePicker value={hoveredRange} onChange={(e) => { setHoveredRange(e); setIsFilterApplied(true); }} range rangeHover numberOfMonths={2} placeholder="Select Dates" onClose={() => { if (isFilterApplied) { getGatepassRequestStatusInfo(); } }} /></div>
        {loader ? (
          <div className="row">
            <SkeletonCard numSkeletons={4} height={'90px'} />
          </div>
        ) : tabsList.length !== 0 ? (
          <div className="outpass-list">
            {tabsList?.map((item) => (
              <div key={item.employee_id} className="gatekeeper-list-card" 
              style={{ borderRight: item?.is_approved ? "6px solid #0ba70bff" : item?.is_rejected ? "6px solid #e91919ff" : "6px solid #fdd63c"}}>
                <div className="d-flex align-items-center gap-2">
                  <img src={item?.image_url ? item?.image_url : "./assets/grey-user-icon.png"} className="outpasslist-profile-image" alt="" onError={(e) => { e.target.onerror = null; e.target.src = "/assets/grey-user-icon.png"; }} />
                  <div>
                    <h3 style={{ fontSize: '18px', marginBottom: '0px !important' }}>{item.user_display_name}</h3>
                    <div style={{ color: 'gray' }}>{item.employee_id} | {item?.apply_datetime && dateConvert(item?.apply_datetime, "date-time-months")}</div>
                  </div>
                </div>
                <div className="d-flex justify-content-between mt-2">
                  <div><b>Request To : </b>{item?.requested_user_name}</div>
                  <div><b>Status : </b> <span>{item?.request_status}</span></div>
                </div>
                <div><b>Gate Name : </b> {item.gate_name}</div>
                <div><b>Requested Out Time : </b> {item.user_out_datetime ? convertTo12HourFormat(item?.user_out_datetime?.split("T")[1]) : ""}</div> 
                <div className="d-flex justify-content-between" >
                  <div><b>Out Time : </b>{item?.actual_out_datetime ? convertTo12HourFormat(item?.actual_out_datetime?.split("T")[1]) : <FontAwesomeIcon icon="fa-solid fa-person-walking-arrow-loop-left" className="c-pointer" style={{ fontSize: "14px", color: "gray" }} onClick={() => { setShowPopup({ show: true, data: item, key: "outTime" }) }} />}    </div>
                  {
                    item?.actual_out_datetime && <div><b>In Time: </b>  {item?.in_datetime ? convertTo12HourFormat(item?.in_datetime?.split("T")[1]) : <FontAwesomeIcon icon="fa-solid fa-person-walking-arrow-loop-left" className="c-pointer" style={{ fontSize: "14px", color: "gray" }} onClick={() => { setShowPopup({ show: true, data: item, key: "inTime" }) }} />} </div>
                  }
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className='text-center'>
            <img src={nodata} alt="data not found" />
            <p className='text-center red mt-3'> Data Not Found</p>
          </div>
        )
        }
      </div>
      <CommanDialog
        visible={showPopup?.show}
        message={showPopup?.key === "outTime" ? "Are you sure the selected person has left?" : "Are you sure the selected person has arrived?"}
        handleClose={() => { setShowPopup({ show: false, data: null, key: "" }) }}
        handleFun={() => {
          handleActions(showPopup?.key, showPopup?.data)
        }}
      />
    </div>
  )
};

export default GateKeeper;
